import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-slate-50" data-id="element-317" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-318" data-mp="cn7soxye8i0x">
        <div className="text-center mb-16" data-id="element-319" data-mp="cm51eox5sdkh">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-blue-950" data-id="element-320" data-mp="7qhc89iofkez">
            THE 6-IN-1 DOG GROOMING INSTRUCTOR <span className="text-orange-500" data-id="element-321" data-mp="3g5hjngqktuaq">READY</span> SYSTEM
          </h2>
          <p className="text-xl text-slate-700" data-id="element-322" data-mp="3c4xlqay6imnj">
            Professional Foundations · Coat Preparation · Clippers · Scissors · Detail Work ·
            Complete Styling
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-323" data-mp="3l3j1jyc9nnkm">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-2 border-orange-500 shadow-lg shadow-blue-950/10' : 'border-slate-200 shadow-sm shadow-blue-950/5'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-324" data-mp="2xdfa0pccre9z" data-mpi={index}>
              {volume.popular && <div className="absolute top-7 right-[-44px] bg-orange-500 text-white font-bold text-xs py-1 px-10 rotate-45 shadow whitespace-nowrap" data-id="element-325" data-mp="1qizbil4ulcgn">
                  {volume.popularLabel ?? 'MOST POPULAR'}
                </div>}

              <div className="flex items-center gap-4 mb-6 pr-10" data-id="element-326" data-mp="24hgs7ywc5op2">
                <span className="w-12 h-12 rounded-xl bg-blue-600 text-white font-extrabold text-2xl flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-327" data-mp="3bu94dlqajvwh">
                  {index + 1}
                </span>
                <div data-id="element-328" data-mp="1gsx9u2wze9bc">
                  <div className="text-blue-600 font-bold text-sm uppercase tracking-wider" data-id="element-329" data-mp="1brq0w0j3r433">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-bold tracking-tight leading-tight mt-1 text-blue-950" data-id="element-330" data-mp="1pqz7q9lf4lue">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-blue-950 font-semibold mb-6 border-l-4 border-orange-500 pl-4" data-id="element-331" data-mp="x3d2yy0gfb5y">
                {volume.subtitle}
              </p>

              {(volume.intro.length > 0 || volume.questions || volume.highlight) && <div className="mb-6 space-y-2" data-id="element-332" data-mp="121wtzctwnd56">
                  {volume.intro.map(paragraph => <p key={paragraph} className="text-slate-800 text-sm leading-relaxed" data-id="element-333" data-mp="ec2gqu5obmke">
                      {paragraph}
                    </p>)}
                  {volume.questions && <ul className="grid sm:grid-cols-2 gap-2 pt-1" data-id="element-334" data-mp="2l02tyke8u93p">
                      {volume.questions.map(question => <li key={question} className="text-blue-600 font-semibold text-sm bg-blue-50 border border-blue-100 rounded-lg px-3 py-2" data-id="element-335" data-mp="2ps4c2my3eu1n">
                          {question}
                        </li>)}
                    </ul>}
                  {volume.highlight && <p className="text-white font-bold text-base bg-blue-950 border-l-4 border-orange-500 rounded-lg px-4 py-3" data-id="element-336" data-mp="38ovuyv9q3756">
                      {volume.highlight}
                    </p>}
                  {volume.afterHighlight && <p className="text-slate-800 text-sm leading-relaxed" data-id="element-337" data-mp="1jbin4w2ej0zb">{volume.afterHighlight}</p>}
                </div>}

              <div data-id="element-338" data-mp="1obn38kzedtp0">
                <div data-id="element-339" data-mp="1o7zaho1s1bbc">
                  <p className="text-blue-950 font-semibold text-sm mb-3" data-id="element-340" data-mp="23kif7t1a4101">{volume.bulletsIntro}</p>
                  <ul className={`mb-6 ${volume.bullets.length > 10 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start' : 'space-y-3'}`} data-id="element-341" data-mp="1ysqmbbunhj6q">
                    {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-342" data-mp="2mhjlriahe963">
                        <CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" data-id="element-343" data-mp="2igpucextyc8g" />
                        <span className="text-slate-800 text-sm" data-id="element-344" data-mp="2dhn2xxarw4iy">{bullet}</span>
                      </li>)}
                  </ul>
                </div>

                {volume.secondaryBullets && <div data-id="element-345" data-mp="12412vh3dkiin">
                    <p className="text-blue-950 font-semibold text-sm mb-3" data-id="element-346" data-mp="124kjmuhah0v3">
                      {volume.secondaryBulletsIntro}
                    </p>
                    <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start" data-id="element-347" data-mp="n0hug2r3qnnr">
                      {volume.secondaryBullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-348" data-mp="rwyjr0a1f82f">
                          <CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" data-id="element-349" data-mp="wwkwl8lyemap" />
                          <span className="text-slate-800 text-sm" data-id="element-350" data-mp="11pnolcb31nos">{bullet}</span>
                        </li>)}
                    </ul>
                  </div>}
              </div>

              {volume.sequence && <div className="mb-6" data-id="element-351" data-mp="1fowwlop4xbho">
                  <p className="text-blue-950 font-semibold text-sm mb-2" data-id="element-352" data-mp="1fpyiypblpkep">{volume.sequenceIntro}</p>
                  <p className="text-blue-600 font-bold text-sm bg-blue-50 border border-blue-100 rounded-lg px-3 py-2" data-id="element-353" data-mp="1kmf9tra6qcvh">
                    {volume.sequence}
                  </p>
                </div>}

              <div className="bg-amber-50 border border-amber-200/70 border-l-4 border-l-orange-500 rounded-xl p-4 mt-auto" data-id="element-354" data-mp="3mfd4lsnivfj2">
                <span className="text-blue-950 font-bold block mb-1" data-id="element-355" data-mp="39fc3oa2u7i5l">RESULT</span>
                {volume.resultLead && <p className="text-slate-800 text-sm" data-id="element-356" data-mp="3od4jl3caq8kb">
                    {volume.resultLead}{' '}
                    <span className="font-semibold text-blue-950" data-id="element-357" data-mp="3jd8ndq9ublfb">{volume.resultQuote}</span>
                  </p>}
                <p className="text-slate-800 text-sm" data-id="element-358" data-mp="16au8idb316l">{volume.result}</p>
                {volume.resultEmphasis && <p className="mt-2 text-xl font-extrabold tracking-tight text-orange-500" data-id="element-359" data-mp="3sc3st0528rhk">
                    {volume.resultEmphasis}
                  </p>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}